"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelect = exports.SelectProvider = void 0;
const react_1 = __importDefault(require("react"));
const defaultProps = {
    theme: "DEFAULT",
    defaultCopy: {
        placeholder: "Please select",
        headingAllOptions: "Add all options",
        headingContent: "Select all",
        valueSelectAll: "Select individual options",
    },
    disabled: false,
    onChangeHandler: () => null,
    id: "",
    options: [],
    error: false,
    zIndex: 1,
    label: "",
};
const SelectContext = react_1.default.createContext({});
const SelectProvider = ({ props, children }) => {
    return (react_1.default.createElement(SelectContext.Provider, { value: Object.assign(Object.assign({}, defaultProps), props) }, children));
};
exports.SelectProvider = SelectProvider;
const useSelect = () => react_1.default.useContext(SelectContext);
exports.useSelect = useSelect;
//# sourceMappingURL=useSelect.js.map